import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

// The Today page loads in its own chunk with its messages, so the initial JS does not grow
// (spec 026).
const TodayPage = lazy(() => import('../components/today/TodayPage.js'))

export const Route = createFileRoute('/')({
  component: () => (
    <Suspense fallback={null}>
      <TodayPage />
    </Suspense>
  ),
})
